<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-user-list">
       
    

    <vx-card :title='user_data[0].prenom+" "+user_data[0].nom ' class="mb-base">
      <div class="flex flex-wrap items-center">

        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ usersData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : usersData.length }} of {{ usersData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!-- ADD NEW -->
          
        
          <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Recherche..." />
          <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

          <!-- ACTION - DROPDOWN 
          <vs-dropdown vs-trigger-click class="cursor-pointer">

            <div class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
              <span class="mr-2 leading-none">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>CSV</span>
                </span>
              </vs-dropdown-item>
              

            </vs-dropdown-menu>
          </vs-dropdown>
          -->
          
      </div>

      
      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="usersData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </vx-card>
  </div>

</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module


// Cell Renderer
import CellRendererLink from "./user-list/cell-renderer/CellRendererLink.vue"
import CellRendererStatus from "./CellRendererStatus.vue"
import CellRendererVerified from "./user-list/cell-renderer/CellRendererVerified.vue"
import CellRendererActions from "./user-list/cell-renderer/CellRendererActions.vue"
import moduleseance from '@/store/seance/moduleseance.js'
import modulecandidat from '@/store/candidat/modulecandidat.js'

export default {
  components: {
    
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
  },
  data() {
    return {
      //ajout
      user_data:null,
      addNewDataSidebar: false,
      sidebarData: {},
      // Filter Options
      domaineFilter: { label: 'All', value: 'all' },
      domaineOptions: [],

      gradeFilter: { label: 'All', value: 'all' },
      grade_choices: [
        { label: 'Professeur', value: 'Professeur' },
        { label: 'Maître de conférences', value: 'Maître de conférences' },
        { label: 'Maître assistant', value: 'Maître assistant' },
        { label: 'Assistant', value: 'Assistant' },
        { label: 'Professeur technologue', value: 'Professeur technologue' },
        { label: 'Maître technologue', value: 'Maître technologue' },
        { label: 'Technologue', value: 'Technologue' },
        { label: 'Assistant technologue', value: 'Assistant technologue' },
      ],

      isVerifiedFilter: { label: 'All', value: 'all' },
      isVerifiedOptions: [
        { label: 'All', value: 'all' },
        { label: 'Yes', value: '1' },
        { label: 'No', value: '0' },
      ],

      departmentFilter: { label: 'All', value: 'all' },
      departmentOptions: [
        { label: 'All', value: 'all' },
        { label: 'Sales', value: 'sales' },
        { label: 'Development', value: 'development' },
        { label: 'Management', value: 'management' },
      ],

      searchQuery: "",

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
         
        {
          headerName: 'Formation',
          field: 'titre',
          filter: true,
          width: 180,
          
        },
        {
          headerName: 'Groupe',
          field: 'numero',
          filter: true,
          width: 180,
        },
        {
          headerName: 'Date',
          field: 'date',
          filter: true,
          width: 200,
        },
        {
          headerName: 'Time',
          field: 'time',
          filter: true,
          width: 200,
        },
        {
          headerName: 'Etat',
          field: 'presance',
          filter: true,
          width: 150,
          // cellRendererFramework: 'CellRendererStatus'
        },
      ],

      // Cell Renderer Components
      components: {
    
        CellRendererStatus,
        
      }
    }
  },
  watch: {
    domaineFilter(obj) {
      this.setColumnFilter("nom_domaine", obj.value)
    },
    gradeFilter(obj) {
      this.setColumnFilter("grade", obj.value)
    },
    isVerifiedFilter(obj) {
      let val = obj.value === "all" ? "all" : obj.value == "yes" ? "true" : "false"
      this.setColumnFilter("is_verified", val)
    },
    departmentFilter(obj) {
      this.setColumnFilter("department", obj.value)
    },
  },
  computed: {
    
    usersData() {
      
      console.log('ffrfrf',this.$store.state.seance.candidat_seances)
      return this.$store.state.seance.candidat_seances
    },
    
   domaine_choices() {
        let opts=[];
          for (var users of this.$store.state.domaine.users) {
              opts.push({label: users.nom_domaine, value: users.nom_domaine});
            }
            opts.unshift({ label: 'All', value: 'all' });
      return opts
    },
    
    paginationPageSize() {
      if(this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if(this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    //ajout
    fetch_user_data(userId) {
      
      this.$store.dispatch("candidat/fetchUser_inscrie", userId)
        .then(res => { this.user_data = res.data })
        .catch(err => {
          if(err.response.status === 404) {
            this.user_not_found = true
            
            return
          }
          console.error(err) })
    },
    addNewData() {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    toggleDataSidebar(val=false) {
      this.addNewDataSidebar = val
    },
  
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if(val !== "all") {
        modelObj = { type: "equals", filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.domaineFilter = this.gradeFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if(this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container")
      header.style.left = "-" + String(Number(header.style.transform.slice(11,-3)) + 9) + "px"
    }
  },
  created() {
    console.log("*********candidat************")
    if(!moduleseance.isRegistered) {
      this.$store.registerModule('seance', moduleseance)
      moduleseance.isRegistered = true
    }
    console.log('rr',this.$route.params.userId,this.$route.params.classId)
    const itemm={id:this.$route.params.userId,class_id:this.$route.params.classId}
    this.$store.dispatch("seance/fetchSeancesCandidatParticipationId",itemm).catch(err => { console.error(err) })
   if(!modulecandidat.isRegistered) {
      this.$store.registerModule('candidat', modulecandidat)
      modulecandidat.isRegistered = true
    }
    this.fetch_user_data(this.$route.params.userId)

   
/*
   for (let pas = 0; pas < this.domaineData.length; pas++) {
   this.domaineOptions[pas].label = this.domaineData[pas].nom
   this.domaineOptions[pas].value = this.domaineData[pas].nom
   console.log("this.domaineOptions",pas+1,this.domaineOptions[pas].label)
   console.log("this.domaineOptions",pas+1,this.domaineOptions[pas].value)
   }
   this.domaineOptions.unshift({ label: 'All', value: 'all' });
   console.log("this.domaineOptions",this.domaineOptions)
    this.domaineOptions[0].label = resp.data[0].nom
    this.domaineOptions[0].value = resp.data[0].nom
    this.domaineOptions[1].label = resp.data[1].nom
    this.domaineOptions[1].value = resp.data[1].nom
    console.log("this.domaineOptions",this.domaineOptions[0].label)
    console.log("this.domaineOptions",this.domaineOptions[0].value)
    console.log("this.domaineOptions",this.domaineOptions[1].label)
    console.log("this.domaineOptions",this.domaineOptions[1].value)
    //console.log("this.$store.state.userManagement.user",this.$store.state.userManagement.users)

    /*axios.get("http://127.0.0.1:8000/api/getdomaine").then(resp => {
     
     this.domaineOptions = resp.data
     

     console.log("this.domaineOptions",this.domaineOptions)
     console.log("this.domaineOptions",this.domaineOptions.length)
 
  for (let pas = 0; pas < this.domaineOptions.length; pas++) {
  this.domaineOptions[pas].label = resp.data[pas].nom
  this.domaineOptions[pas].value = resp.data[pas].nom
  console.log("this.domaineOptions",pas+1,this.domaineOptions[pas].label)
  console.log("this.domaineOptions",pas+1,this.domaineOptions[pas].value)
 }
this.domaineOptions.unshift({ label: 'All', value: 'all' });
console.log("this.domaineOptions",this.domaineOptions)
    /*this.domaineOptions[0].label = resp.data[0].nom
    this.domaineOptions[0].value = resp.data[0].nom
    this.domaineOptions[1].label = resp.data[1].nom
    this.domaineOptions[1].value = resp.data[1].nom
    console.log("this.domaineOptions",this.domaineOptions[0].label)
    console.log("this.domaineOptions",this.domaineOptions[0].value)
    console.log("this.domaineOptions",this.domaineOptions[1].label)
    console.log("this.domaineOptions",this.domaineOptions[1].value)*/
     //})
  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
